export const initialState = {
  fromdb: null,
  errorModal: {
    show: false,
    message: null,
  },
  isLoading: false,
  error: null,
};
